<span class="item-container" (click)="copy()">
    <div class="item">
        {{text}}
        <mat-icon class="show-on-hover">file_copy</mat-icon>
    </div>
</span>